import { useMutation, useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { AxiosResponse } from 'axios'

import { axiosInstance } from '../../helpers'
import { GuestCard, GuestCardPremiumOption } from '../../models/Outreach/types'
import { School } from '../../models/types'
import { UnitConfigAreaCounts } from '../../models/Config/types'

// Hook to fetch guest card form data by token
export const useGuestCardForm = (token: string | undefined) => {
    const { data, isLoading, error } = useQuery<
        AxiosResponse<GuestCardFormResponse>,
        Error
    >({
        queryKey: ['guest-card-form', token],
        queryFn: () => axiosInstance.get(`/outreach/guest-card/${token}/`),
        enabled: !!token,
    })

    const submitGuestCardForm = useMutation({
        mutationFn: (request: GuestCardFormRequest) =>
            axiosInstance.post(`/outreach/guest-card/${token}/`, request),
        onSuccess: () => {
            toast.success('Guest card form submitted successfully')
        },
        onError: (error) => {
            toast.error('Failed to submit guest card form')
        },
    })

    return {
        formData: data?.data,
        isLoading,
        error,
        submitGuestCardForm,
    }
}

export interface GuestCardFormResponse {
    guest_card: GuestCard
    name: string | null
    email: string | null
    phone: string | null
    unit_configs: UnitConfigAreaCounts[]
    premiums?: GuestCardPremiumOption[]
    schools?: School[]
    apartment_name: string
    already_submitted?: boolean
    default_move_in_date?: string | null
    default_move_out_date?: string | null
}

export interface GuestCardFormRequest {
    name?: string
    email?: string
    phone?: string
    floor_plan?: number
    preferred_premiums?: number[]
    preferred_rent_cost?: string
    preferred_move_in_date?: string
    preferred_move_out_date?: string
    additional_occupants?: {
        name: string
        email: string
        phone: string
    }[]
    school?: number
    additional_requests?: string
    custom_questions?: {
        question: number
        answer: string
    }[]
}
